// Typelizer digest 0f6f0be1560e890ae5c158ae993348d7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /team/invitations */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/team/invitations', {}, options),
    method: 'post',
  }),

  /** DELETE /team/invitations/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/team/invitations/:id', params, options),
    method: 'delete',
  }),
}
